import { createContext } from "react";

export const movieContext = createContext(null);
